export default __webpack_public_path__ + "static/home-m-slogan-1418267f95f6778702bcad0bc2cbe283.png";